export const environment = {
  baseUrl: location.host,
  appName: 'Nft Folks',
  appUrl: 'nft.ifelse.finance',
  envName: 'PROD',
  production: true,
  test: false,
  appLogo: 'https://images.web3auth.io/web3auth-logo-w.svg',
  ethRPC: 'https://rpc.ankr.com/eth',
  versions: {
    app: '',
  },
};
